/* eslint-disable no-useless-escape */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReplaySubject, takeUntil } from 'rxjs';
import { INotes } from 'src/app/features/models/inotes.modal';
import { ICompany } from 'src/app/shared/models/i-company.modal';
import { PrecastService } from 'src/app/shared/services/precast.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
    selector: 'app-accounting-info',
    templateUrl: './accounting-info.component.html',
    styleUrls: ['./accounting-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountingInfoComponent implements OnInit, OnDestroy {
  @Input() data: ICompany;
  @Input() billing:ICompany;
  @Input() projectId:string;
  @Input() notes:INotes[];
  @Input() additionalNotes:string;
  companyPanelOpenState = false;
  notesPanelOpenState = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  public additionalNotesError = false;
  // public additionalNotes: string;
  @Output() notesValue = new EventEmitter<string>();
  response: any;
  constructor(
    private precastService: PrecastService,
    // private mdr: MatDialogRef,
    private snackBar: MatSnackBar,
    public userService: UserService,

  ) {

  }

  ngOnInit(): void {
    if (this.projectId) {
      this.fetchNotes(this.projectId);
    }
  }

  onInputChange(event: Event): void {
    const inputElement = event.target as HTMLTextAreaElement;
    const currentValue = inputElement.value;
    const validInputRegex = /^[A-Za-z0-9\s!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|`~.-]*$/;
    if (!validInputRegex.test(currentValue)) {
      inputElement.value = currentValue.replace(/[^A-Za-z0-9\s!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|`~.-]/g, '');
    }
    if (currentValue.trim() === '') {
      inputElement.value = '';
    }

    this.additionalNotes = inputElement.value;
    this.notesValue.emit(this.additionalNotes);
    if (this.additionalNotes.trim() === '') {
      this.additionalNotes = '';
    }
  }

  private fetchNotes(projectID: string): void {
    this.precastService
      ?.getNotesbyId(projectID)
      ?.pipe(takeUntil(this.destroyed$))
      ?.subscribe({
        next: (response: INotes[]) => {
          this.notes = response;
        },
        error: () => {},
      });
  }

  getCompanyAddress(): string {
    return [this.data?.streetAddress, this.data?.state?.name, this.data?.city?.name, this.data?.postalCode]
      .filter((item) => item)
      .join(', ');
  }

  getBillingAddress(): string {
    return [this.billing?.streetAddress, this.billing?.state?.name, this.billing?.city?.name, this.billing?.postalCode]
      .filter((item) => item)
      .join(', ');
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onCompanyPanelOpened() {
    this.companyPanelOpenState = true;
    this.notesPanelOpenState = false;
  }

  onCompanyPanelClosed() {
    this.companyPanelOpenState = false;
  }

  onNotesPanelOpened() {
    this.notesPanelOpenState = true;
    this.companyPanelOpenState = false;
  }

  onNotesPanelClosed() {
    this.notesPanelOpenState = false;
  }
}
